import * as React from 'react';
import { 
  Typography, 
  Grid, 
  Paper, 
  Box, 
  Divider, 
  Avatar,
  Chip,
} from '@mui/material';
import { useAuth } from '../../context/AuthContext.tsx';
import SettingsIcon from '@mui/icons-material/Settings';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import NatureIcon from '@mui/icons-material/Nature';
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export default function Configs() {
  const { userData } = useAuth();

  const Section = ({ title, icon, children }: { 
    title: string; 
    icon?: React.ReactNode;
    children: React.ReactNode 
  }) => (
    <Paper elevation={2} sx={{ 
      p: 4, 
      mb: 4,
      borderRadius: 2,
    }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 2,
        gap: 2
      }}>
        {icon}
        <Typography variant="h5" fontWeight="600" color="text.primary"
          sx={{
            fontSize: {
              xs: '1.1rem',
              sm: '1.4rem',
              md: '1.6rem'
            }
          }}>
          {title}
        </Typography>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        {children}
      </Grid>
    </Paper>
  );

  // Componente de informação aprimorado
  const Info = ({ label, value }: { label: string; value: any }) => {
    return (
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        {value ? (
          <Chip 
            onClick={() => console.info(value)}
            label={value} 
            color="primary" 
            variant="filled"
            sx={{
              borderRadius: 1,
              padding: 1,
              height: 'auto',
              '& .MuiChip-label': {
                display: 'block',
                whiteSpace: 'normal',
                padding: 1.5,
                fontSize: {
                  xs: 12,
                  sm: 14,
                  md: 16,
                }
              }
            }}
          />
        ) : (
          <Typography variant="body2" color="text.disabled" fontStyle="italic">
            Não informado
          </Typography>
        )}
      </Grid>
    );
  };

  return (
    <Box sx={{ 
      p: 4,
      minHeight: '100vh'
    }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        mb: 4,
        gap: 2
      }}>
        <Avatar sx={{ 
          width: 56, 
          height: 56
        }} >
          <SettingsIcon fontSize="large" sx={{ color: '#fff' }}/>
        </Avatar>
        <Typography variant="h4" fontWeight="bold" sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' }}}>
          Configurações do Sistema - {userData?.precO_TABELA}
        </Typography>
      </Box>

      {/* Cliente */}
      <Section 
        title="Dados do Cliente" 
        icon={
        <Avatar sx={{ bgcolor: 'primary' }}>
          <PersonIcon sx={{ color: '#fff' }}/>
        </Avatar>}
      >
        <Info label="Código" value={userData.clI_CODIGO} />
        <Info label="Nome" value={userData.clI_NOME} />
        <Info label="CNPJ/CPF" value={userData.clI_CNPJCPF} />
        <Info label="Telefone" value={userData.clI_RESTELEFONE} />
        <Info label="CEP" value={userData.clI_RESCEP} />
      </Section>

      {/* Cidade */}
      <Section 
        title="Localização" 
        icon={
          <Avatar sx={{ bgcolor: 'primary' }}>
            <LocationCityIcon sx={{ color: '#fff' }}/>
          </Avatar>
        }
      >
        <Info label="Código" value={userData.cidadE_CODDNERESID} />
        <Info label="Cidade" value={userData.cidadE_NOME + " - " + userData.cidadE_UF} />
        <Info label="Bairro" value={userData.clI_RESBAIRRO} />
      </Section>

      {/* Banco */}
      <Section 
        title="Banco" 
        icon={
          <Avatar sx={{ bgcolor: 'primary' }}>
            <AccountBalanceIcon sx={{ color: '#fff' }}/>
          </Avatar>
        }
      >
        <Info label="Código" value={userData.bancO_CODIGO} />
        <Info label="Nome" value={userData.bancO_NOME} />
      </Section>

      {/* Natureza */}
      <Section 
        title="Natureza da Operação" 
        icon={
          <Avatar sx={{ bgcolor: 'primary' }}>
            <NatureIcon sx={{ color: '#fff' }}/>
          </Avatar>
        }
      >
        <Info label="Código" value={userData.natU_CODIGO} />
        <Info label="Nome" value={userData.naturezA_NOME} />
      </Section>

      {/* CONDIÇÃO DE PAGAMENTO */}
      <Section
        title="Condições de Pagamento"
        icon={
          <Avatar sx={{ bgcolor: 'primary'}}>
            <AttachMoneyIcon sx={{ color: "#fff" }}/>
          </Avatar>
        }
      >
        <Info label='Limite de Crédito' value={userData.clI_LIMITECRED}/>

        {
          userData.conD_DESDOBRAMENTO01 !== "001" ? 
          <Info label='Primeira Parcela' value={userData.conD_DESDOBRAMENTO01}/> 
          : null
        }

        {
          userData.conD_DESDOBRAMENTO02 !== "000" ? 
          <Info label='Segunda Parcela' value={userData.conD_DESDOBRAMENTO02}/>
          : null
        }

        {
          userData.conD_DESDOBRAMENTO03 !== "000" ? 
          <Info label='Terceira Parcela' value={userData.conD_DESDOBRAMENTO03}/>
          : null
        }

        {
          userData.conD_DESDOBRAMENTO04 !== "000" ? 
          <Info label='Quarta Parcela' value={userData.conD_DESDOBRAMENTO04}/>
          : null
        }

      </Section>
    </Box>
  );
}